import React from 'react';
import { CSSTransition } from 'react-transition-group';
import '../styles/confirmationDialog/ConfirmationDialog.css' // Custom CSS for animations

const ConfirmationDialog = ({ isOpen, message, onConfirm, onCancel }) => {
    return (
        <CSSTransition
            in={isOpen}
            timeout={300}
            classNames="fade"
            unmountOnExit
        >
            <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
                <div className="bg-white rounded-xl p-6 shadow-2xl transform transition-transform duration-300 ease-in-out w-96">
                    <p className="text-gray-900 text-lg font-semibold mb-4">{message}</p>
                    <div className="flex justify-end space-x-2">
                        <button
                            onClick={onCancel}
                            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition-colors duration-200"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onConfirm}
                            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition-colors duration-200"
                        >
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        </CSSTransition>
    );
};

export default ConfirmationDialog;